<template>
  <div>
    {{ serviceId }}
  </div>
</template>

<script>
export default {
  name: 'Service',
  props: {
    serviceId: {
      type: String,
      required: true,
    },
  },
};
</script>
